import { TContainerVariant } from './types'

type ContainerVariantType = Required<
  Record<keyof typeof TContainerVariant, string>
>
export const VariantClasses: ContainerVariantType = {
  [TContainerVariant.normal]: 'max-w-(--breakpoint-xl)',
  [TContainerVariant.small]: 'max-w-(--breakpoint-sm) box-content',
}
